module.exports = __webpack_public_path__ + "static/media/wallpaper.ea036144.jpeg";